import styled from '@emotion/styled';
import { Button } from 'antd';

export const LayoutRoot = styled.div`
  display: flex;
  width: 100%;
  min-height: 100dvh;
  background: #ffffff;
`;

export const PageArea = styled.div<{ $isMobile?: boolean }>`
  margin-left: ${({ $isMobile }) => ($isMobile ? 0 : '70px')};
  width: ${({ $isMobile }) => ($isMobile ? '100%' : 'calc(100% - 70px)')};
  height: 100dvh;
  display: flex;
  flex-direction: column;

  background: ${({ theme }) => (theme as any)?.token?.colorBgLayout || '#fff'};
`;

export const HeaderBar = styled.header<{ $isMobile?: boolean }>`
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
`;

export const ContentWrapper = styled.main<{ $isMobile?: boolean }>`
  flex: 1;
  width: 100%;
  overflow: auto;
  margin-top: ${({ $isMobile }) => ($isMobile ? '56px' : '')};
`;

export const Top = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  gap: 16px;
  padding: ${({ $isMobile }) => ($isMobile ? '16px 16px 12px' : '12px 16px')};
`;

export const Bottom = styled.div`
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
`;

export const MobileActionsBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 20;
  width: 100%;
  height: 0;
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 8px 16px 0;
  background: linear-gradient(
    180deg,
    ${({ theme }) => (theme as any)?.token?.colorBgContainer || '#fff'} 0%,
    rgba(255, 255, 255, 0.78) 66%,
    rgba(255, 255, 255, 0) 100%
  );
  pointer-events: none;
`;

export const MobileActionsLoading = styled.div`
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
`;

export const MobileActionsTrigger = styled(Button)`
  && {
    width: auto;
    min-width: 126px;
    height: 42px;
    padding: 0 14px;
    border-radius: 999px;
    border-color: rgba(31, 41, 55, 0.12);
    background: rgba(255, 255, 255, 0.96);
    color: rgba(17, 24, 39, 0.88);
    font-weight: 650;
    box-shadow:
      0 10px 26px rgba(15, 23, 42, 0.12),
      0 1px 0 rgba(255, 255, 255, 0.9) inset;
    pointer-events: auto;
    transform: translateY(2px);
    backdrop-filter: blur(10px);
  }

  &&:hover,
  &&:focus {
    border-color: rgba(57, 58, 251, 0.34);
    color: #393afb;
    background: #ffffff;
  }
`;

export const MobileActionsSheetHandle = styled.div`
  width: 42px;
  height: 4px;
  border-radius: 999px;
  margin: -4px auto 16px;
  background: rgba(15, 23, 42, 0.14);
`;

export const MobileActionsSheetTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  span {
    font-size: 17px;
    line-height: 1.2;
    font-weight: 700;
    color: rgba(17, 24, 39, 0.92);
  }

  small {
    font-size: 12px;
    line-height: 1.35;
    font-weight: 500;
    color: rgba(107, 114, 128, 0.95);
  }
`;

export const MobileActionsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;

  > * {
    width: 100%;
  }

  > .ant-space {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  > .ant-space > .ant-space-item {
    width: 100%;
  }

  > .ant-btn,
  > a.ant-btn,
  > .ant-space > .ant-space-item > .ant-btn,
  > .ant-space > .ant-space-item > a.ant-btn {
    width: 100%;
    min-height: 46px;
    border-radius: 12px;
    justify-content: center;
  }

  > .ant-popconfirm {
    width: 100%;
  }
`;
